/**
 * Utility functions for timezone handling
 */

/**
 * Convert a date to Indian timezone (IST) string
 * @param date - Date object or date string
 * @param options - Intl.DateTimeFormatOptions for formatting
 * @returns Formatted date string in IST
 */
export function toISTString(
  date: Date | string,
  options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }
): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return dateObj.toLocaleString('en-IN', {
    ...options,
    timeZone: 'Asia/Kolkata'
  });
}

/**
 * Convert a date to Indian timezone (IST) date string only
 * @param date - Date object or date string
 * @returns Formatted date string in IST
 */
export function toISTDateString(date: Date | string): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return dateObj.toLocaleDateString('en-IN', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
}

/**
 * Convert a date to Indian timezone (IST) time string only
 * @param date - Date object or date string
 * @returns Formatted time string in IST
 */
export function toISTTimeString(date: Date | string): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return dateObj.toLocaleTimeString('en-IN', {
    timeZone: 'Asia/Kolkata',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });
} 